import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {FormularioUsuariosExpatriados} from './Formulario/container';

import {EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiText} from '@elastic/eui';
import { ActionType, UPDATE, GET } from '../constants';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import ModalApp from '../../../components/Modal';
import { ExternalFilterUsers } from '../FiltrosExternos';
import { useUserSettings } from '../../../context/CurrentUserContext';

interface Props {
  data: any;
  permisosUser?: any;
  handleCreate(usuario: any): any;
  handleUpdate(usuario: any, ficherosExpatriado: any): any;
  handleAddSociedades(dni:any,sociedades:any): any;
  handleAddDelegados(dni:any,delegados:any): any;
  translate(word:string):string;
}

export const UsuariosExpatriadosScreen = (props: Props) => {
  const ref:any = useRef();
  const{currentUser}:any = useUserSettings();

  let { data, handleUpdate, translate } = props;
  let [isModalVisible, setIsModalVisible] = useState(false);
  let [selected, setSelected] = useState<any>(undefined);
  let [externalFilter, setExternalFilter] = useState<any>(undefined)
  let [actionType, setActionType] = useState<ActionType>(GET);

  useEffect(()=>{closeModal();},[data])

  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const onUpdate = useCallback((newData: any, ficheros: any) => {
    if (handleUpdate && newData) {
      handleUpdate(newData, ficheros)
    }
  },[selected,handleUpdate])

  const onExport = () =>{
    ref && ref.current.onExport();
  }

  const onSelected = (selection: any) => {
    setSelected(selection!==undefined ? selection[0] : undefined)
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected : undefined;
  },[actionType,selected])

  const getHandle = useCallback(() =>{
    if(actionType.tipo === "U"){
        return onUpdate
    }
  },[actionType,onUpdate])


  const Actions: Action[] = useMemo(()=> [
    {handle:onFilterClear,text:translate('limpiar-filtro'),size:"s", isDisabled: false, className: "btnFilterClear"},
    {actionGroup:{actions:[
      {text:translate('datos'),size:"s", isDisabled: false},
      {handle:onExport,text:translate('exportar'),size:"s", isDisabled:false}
    ]}},
    {handle:prepareEdit,text:translate('editar'),color:"secondary",size:"s",isDisabled:(selected===undefined)}
  ],[selected,prepareEdit,translate])

  const contentModal = useCallback(() =>  
  {return <FormularioUsuariosExpatriados handle={getHandle()} selected={getSelected} currentUser={currentUser} onClose={closeModal} translate={translate}/>
  },[getHandle,getSelected,closeModal,currentUser])
  
  const modal = useMemo(() => {
    switch (actionType.tipo) {
      case 'U':
        return <ModalApp isOpen={isModalVisible} title={translate(actionType.titleKey)} onClose={closeModal} content={contentModal()}/> 
    }
  },[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selected={selected}
          type={actionType.tipo}
          selector={false}
          menu={false}
          onSelected={onSelected}
          ref={ref}
          externalFilter={externalFilter}
        />
        {modal}
      </>
    )
  },[data,modal,onUpdate,onSelected,actionType,externalFilter])

  return(
    <>
    <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter" wrap>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup style={{backgroundColor:'#ffdc9c',border:'1px solid #ffdc9c',boxShadow:externalFilter&&externalFilter.expatriadosNoFacturables ? '0px 0px 7px #005c9b' : 'none'}} gutterSize="s" alignItems="center" justifyContent="flexStart" >
            <EuiFlexItem><EuiText size='xs'>{translate('expatriado-sin-configurar')}</EuiText></EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem grow={false}>
          <EuiFlexGroup style={{backgroundColor:'#a8ffaf',border:'1px solid #a8ffaf',boxShadow:externalFilter&&externalFilter.expatriadosFacturables ? '0px 0px 7px #005c9b' : 'none'}} gutterSize="s" alignItems="center" justifyContent="flexStart" >
            <EuiFlexItem><EuiText size='xs'>{translate('expatriado-facturable')}</EuiText></EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>

        <EuiFlexItem grow={false}>
          <ExternalFilterUsers handleExternalFilter={setExternalFilter} translate={translate} showNoExpatriados={false}/>
        </EuiFlexItem>
        <EuiFlexItem>
          {<Menu actions={Actions} className="actions"/>}
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      {getView}
    </>
  )
};